import { TAppconfig } from "../../.env";
import buildConfig from "@/../.env.json";

declare global {
    interface Window {
        __APP_CONFIG__?: Partial<TAppconfig>;
    }
}
const runtimeConfig = window.__APP_CONFIG__;
if (!runtimeConfig) {
    console.error(
        "[appConfig] 未检测到 window.__APP_CONFIG__，正在使用构建时配置。",
        "如果不是本地调试环境, 请检查是否正确加载了vue3_header.html"
    );
}

// 会把env配置文件信息在页面上公开一份:__APP_CONFIG__
// 如果没有这个信息就继续使用import引入的json
export const appConfig: TAppconfig = {
    ...buildConfig,
    ...runtimeConfig,
};